function initializeSymbolismStories(root = document) {
  root.querySelectorAll?.('[data-symbolism-story]:not([data-story-ready])').forEach((story) => {
    story.dataset.storyReady = 'true';
    const mediaScenes = [...story.querySelectorAll('.symbolism-story__media [data-symbolism-scene]')];
    const copyScenes = [...story.querySelectorAll('.symbolism-story__copy [data-symbolism-scene]')];
    const videos = [...story.querySelectorAll('video')];
    const dots = [...story.querySelectorAll('[data-symbolism-dot]')];
    const sceneCount = Math.min(mediaScenes.length, copyScenes.length);
    let activeIndex = -1;

    const activate = (index) => {
      index = Math.max(0, Math.min(sceneCount - 1, index));
      if (activeIndex === index) return;
      activeIndex = index;
      mediaScenes.forEach((scene, sceneIndex) => scene.classList.toggle('is-active', sceneIndex === index));
      copyScenes.forEach((scene, sceneIndex) => scene.classList.toggle('is-active', sceneIndex === index));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      videos.forEach((video, videoIndex) => {
        if (videoIndex === index) video.play().catch(() => {});
        else video.pause();
      });
    };

    const update = () => {
      const rect = story.getBoundingClientRect();
      const distance = Math.max(1, story.offsetHeight - innerHeight);
      const progress = Math.max(0, Math.min(0.999, -rect.top / distance));
      activate(Math.floor(progress * sceneCount));
      story.style.setProperty('--story-parallax', `${(progress - .5) * 24}px`);
    };

    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      const top = story.offsetTop + ((story.offsetHeight - innerHeight) * index / Math.max(1, sceneCount - 1));
      scrollTo({ top, behavior: 'smooth' });
    }));

    addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update);
    update();
  });
}

initializeSymbolismStories();
new MutationObserver((mutations) => mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
  if (node.nodeType === Node.ELEMENT_NODE) initializeSymbolismStories(node);
}))).observe(document.documentElement, { childList: true, subtree: true });
